import { type CreateRoleInputType } from '@shelflix/schemas/role/create';
import { create } from 'zustand';

interface RoleFormStore {
  formData: Partial<CreateRoleInputType>;
  setFormData: (data: Partial<CreateRoleInputType>) => void;
  resetForm: () => void;
}

export const useRoleFormStore = create<RoleFormStore>((set) => ({
  formData: { permissions: [] },
  setFormData: (data) => set((state) => ({ formData: { ...state.formData, ...data } })),
  resetForm: () => set({ formData: {} }),
}));
